export default "/images/framework/BattleAgainEng.9c8ad400.svg?9c8ad400";